import Lenis from 'lenis'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Draggable } from 'gsap/Draggable'

gsap.registerPlugin(ScrollTrigger, Draggable)

class Scroller {
  constructor() {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), //eslint-disable-line
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 2,
    })

    window.lenis = lenis
    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => {
      window.lenis.raf(time * 1000)
    })

    const thumb = document.querySelector('[data-scrollbar-thumb]')
    const thumbs = document.querySelectorAll('[data-scrollbar-thumb]')
    const thumbHeight = thumb.getBoundingClientRect().height

    lenis.on('scroll', ({ progress }) => {
      thumb.style.transform = `translate3d(0,${progress * (window.innerHeight - thumbHeight)}px,0)`
      ScrollTrigger.update()
    })

    const inner = document.querySelector('[data-scrollbar-inner]')
    const maxThumbScroll = inner.clientHeight - thumb.clientHeight

    Draggable.create(thumb, {
      type: 'y',
      bounds: inner,
      onDrag() {
        const progress = this.y / maxThumbScroll
        const newScroll = progress * lenis.limit
        lenis.scrollTo(newScroll, { immediate: true })
      },
    })

    lenis.on('scroll', ({ scroll, limit }) => {
      const progress = scroll / limit
      gsap.to(thumbs[0], { y: progress * maxThumbScroll, duration: 0 })
    })
  }
}

export default Scroller
